import { render, staticRenderFns } from "./SoftSearch.vue?vue&type=template&id=2b22a25c&class=electric-vehicle-soft-search"
import script from "./SoftSearch.vue?vue&type=script&lang=js"
export * from "./SoftSearch.vue?vue&type=script&lang=js"
import style0 from "./SoftSearch.vue?vue&type=style&index=0&id=2b22a25c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports